var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommercePreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 155,
    viewBox: "0 0 355 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10953_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354.667,
    height: 155,
    rx: 16,
    fill: "#73A2FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10953_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 77.5728,
    width: 376,
    height: 113.583,
    fill: "url(#paint0_linear_10953_54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.883,
    cy: 14.7093,
    r: 63.0907,
    fill: "url(#paint1_angular_10953_54)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.883,
    cy: 14.7093,
    r: 62.7234,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.734582
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.064,
    cy: 14.7093,
    r: 63.0907,
    transform: "rotate(90 248.064 14.7093)",
    fill: "url(#paint2_angular_10953_54)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.064,
    cy: 14.7093,
    r: 62.7234,
    transform: "rotate(90 248.064 14.7093)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.734582
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.883,
    cy: 140.891,
    r: 63.0907,
    transform: "rotate(-90 121.883 140.891)",
    fill: "url(#paint3_angular_10953_54)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.883,
    cy: 140.891,
    r: 62.7234,
    transform: "rotate(-90 121.883 140.891)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.734582
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.064,
    cy: 140.891,
    r: 63.0907,
    transform: "rotate(180 248.064 140.891)",
    fill: "url(#paint4_angular_10953_54)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.064,
    cy: 140.891,
    r: 62.7234,
    transform: "rotate(180 248.064 140.891)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.734582
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_10953_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51.0391,
    width: 267,
    height: 53.9218,
    rx: 9.13317,
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10953_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.634 82.8789C103.933 82.8789 101.746 80.6956 101.746 78C101.746 75.3044 103.933 73.1212 106.634 73.1212C109.053 73.1212 111.061 74.8816 111.448 77.1869H116.373C115.958 72.1779 111.758 68.2423 106.634 68.2423C101.237 68.2423 96.8577 72.6129 96.8577 78C96.8577 83.3871 101.237 87.7577 106.634 87.7577C111.758 87.7577 115.958 83.8221 116.373 78.8131H111.448C111.061 81.1184 109.053 82.8789 106.634 82.8789Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_10953_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.959 85V72.1405H132.786C135.691 72.1405 137.262 73.821 137.262 76.1226C137.262 78.4241 135.691 80.0864 132.786 80.0864H129.425V85H126.959ZM134.777 76.2139V76.013C134.777 74.8804 134.065 74.2411 132.713 74.2411H129.425V78.004H132.713C134.065 78.004 134.777 77.3464 134.777 76.2139ZM138.172 78.2049C138.373 76.3966 139.834 75.1727 142.337 75.1727C144.529 75.1727 146.319 76.1226 146.319 78.552V82.5158C146.319 83.0455 146.538 83.1551 146.958 83.1551H147.524V85H146.209C144.894 85 144.382 84.3972 144.401 83.4474V83.356H144.382C143.926 84.5068 142.812 85.2557 141.222 85.2557C139.231 85.2557 137.861 84.178 137.861 82.3696C137.861 80.5065 139.25 79.6297 141.496 79.3192L142.665 79.1365C143.56 79.0086 143.944 78.7164 143.944 78.1136C143.944 77.4743 143.524 76.8897 142.3 76.8897C141.168 76.8897 140.583 77.4012 140.51 78.2049H138.172ZM143.999 81.1275V80.2142C143.816 80.3969 143.433 80.5978 142.866 80.6709L141.862 80.817C140.802 80.9814 140.163 81.4015 140.163 82.1322V82.2418C140.163 82.9907 140.747 83.4656 141.716 83.4656C143.104 83.4656 143.999 82.5158 143.999 81.1275ZM152.776 85.7672C152.027 87.7582 150.968 88.4889 149.068 88.4889H147.041V86.5709H148.959C149.708 86.5709 150.036 86.3882 150.365 85.548L150.657 84.726L146.949 75.4284H149.58L151.918 82.0409H151.936L154.238 75.4284H156.631L152.776 85.7672ZM159.776 75.4284H162.278L164.105 81.9495H164.123L166.06 75.4284H168.306L170.243 81.9313H170.261L172.051 75.4284H174.298L171.43 85.0365H169.055L167.101 78.3328H167.082L165.11 85.0365H162.808L159.776 75.4284ZM177.629 74.3142H177.483C176.661 74.3142 176.022 73.6749 176.022 72.9077C176.022 72.104 176.661 71.4829 177.483 71.4829H177.629C178.451 71.4829 179.072 72.104 179.072 72.9077C179.072 73.6749 178.451 74.3142 177.629 74.3142ZM174.871 77.3281V75.4284H178.743V85H176.369V77.3281H174.871ZM179.847 75.4284H181.929V72.7433H184.304V75.4284H187.263V77.3647H184.304V82.2783C184.304 82.8446 184.541 83.082 185.089 83.082H187.263V85H184.541C182.77 85 181.929 84.1232 181.929 82.4792V77.3647H179.847V75.4284ZM191.014 79.374V85H188.64V71.4464H190.978V76.7801H190.996C191.526 75.7207 192.585 75.1727 193.882 75.1727C195.91 75.1727 197.426 76.5975 197.426 79.0086V85H195.051V79.2644C195.051 77.8579 194.101 77.182 193.078 77.182C192.019 77.182 191.014 77.8761 191.014 79.374ZM207.823 83.1186C209.595 83.1186 210.49 82.1139 210.709 80.9449H213.266C212.81 83.5387 210.801 85.2557 207.896 85.2557C203.932 85.2557 201.85 82.2966 201.85 78.5702C201.85 74.8622 203.951 71.8665 207.896 71.8665C210.782 71.8665 212.792 73.5835 213.23 76.0312H210.636C210.38 74.8256 209.449 74.0037 207.823 74.0037C205.905 74.0037 204.353 75.465 204.353 78.1136V79.0086C204.353 81.6573 205.905 83.1186 207.823 83.1186ZM214.559 85V75.4284H216.842V77.1089H216.86C217.098 76.3052 217.901 75.4102 219.582 75.4102H220.751V77.5839H219.143C217.518 77.5839 216.933 78.3693 216.933 79.648V85H214.559ZM226.948 85.7672C226.199 87.7582 225.139 88.4889 223.24 88.4889H221.212V86.5709H223.13C223.879 86.5709 224.208 86.3882 224.537 85.548L224.829 84.726L221.121 75.4284H223.751L226.089 82.0409H226.107L228.409 75.4284H230.802L226.948 85.7672ZM231.755 75.4284H234.001V77.0359H234.02C234.568 75.9034 235.572 75.1727 237.143 75.1727C239.901 75.1727 241.326 77.5108 241.326 80.2142C241.326 82.8994 239.883 85.2557 237.143 85.2557C235.682 85.2557 234.714 84.6164 234.147 83.6118H234.129V88.5071H231.755V75.4284ZM238.933 79.7941C238.933 78.0771 237.874 77.1089 236.54 77.1089C235.207 77.1089 234.129 78.1319 234.129 79.7941V80.6161C234.129 82.2966 235.207 83.283 236.54 83.283C237.874 83.283 238.933 82.3331 238.933 80.6161V79.7941ZM241.692 75.4284H243.774V72.7433H246.149V75.4284H249.108V77.3647H246.149V82.2783C246.149 82.8446 246.386 83.082 246.934 83.082H249.108V85H246.386C244.615 85 243.774 84.1232 243.774 82.4792V77.3647H241.692V75.4284ZM254.566 85.2557C251.369 85.2557 249.762 82.8994 249.762 80.2142C249.762 77.5291 251.387 75.1727 254.566 75.1727C257.726 75.1727 259.352 77.5473 259.352 80.2142C259.352 82.8994 257.744 85.2557 254.566 85.2557ZM256.977 80.6343V79.8124C256.977 78.0953 255.918 77.1272 254.566 77.1272C253.196 77.1272 252.136 78.1319 252.136 79.8124V80.6343C252.136 82.2966 253.196 83.3012 254.566 83.3012C255.918 83.3012 256.977 82.3331 256.977 80.6343Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_10953_54",
    x: 31.1879,
    y: 47.9315,
    width: 292.624,
    height: 87.2357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6.21519,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10953_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.1076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.21519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10953_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18.2638,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_10953_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.3941
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.538
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.321569 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10953_54",
    result: "effect2_dropShadow_10953_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.95765
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.239072 0 0 0 0 0.743457 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_10953_54",
    result: "effect3_dropShadow_10953_54"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_10953_54",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.776899,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_innerShadow_10953_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.5538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.776899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.242218 0 0 0 0 0.753239 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_10953_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10953_54",
    x: 96.8577,
    y: 68.2423,
    width: 19.5154,
    height: 20.2923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.776899
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.38845
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10953_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_10953_54",
    x: 126.959,
    y: 71.4464,
    width: 132.392,
    height: 17.8376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.776899
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.776899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10953_54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10953_54",
    x1: 0.00000245124,
    y1: 134.364,
    x2: 376,
    y2: 134.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880435,
    stopColor: "#0052FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_10953_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.883 14.7093) rotate(90) scale(63.0907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_10953_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.064 14.7093) rotate(90) scale(63.0907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_10953_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.883 140.891) rotate(90) scale(63.0907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_10953_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.064 140.891) rotate(90) scale(63.0907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10953_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354.667,
    height: 155,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10953_54"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -35,
    width: 376,
    height: 225.6,
    rx: 18.416,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercePreview);
export default __webpack_public_path__ + "static/media/CommercePreview.4cceba775e0dec71143db25caf311be5.svg";
export { ForwardRef as ReactComponent };